import { render } from "./PagoEnBanco.vue?vue&type=template&id=472fef0c&scoped=true"
import script from "./PagoEnBanco.vue?vue&type=script&lang=js"
export * from "./PagoEnBanco.vue?vue&type=script&lang=js"

import "./PagoEnBanco.vue?vue&type=style&index=0&id=472fef0c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472fef0c"]])

export default __exports__